import React, { FunctionComponent } from 'react';

import { useVerticalConfig } from 'providers/vertical';

import { LivePersonMessagingProvider } from './LivePersonMessagingProvider';
import { PillowTalkWrapper } from './PillowTalkMessagingProvider';

interface Props {
  locale: string;
  marketCode: string;
}

const MessagingProviderWrapper: FunctionComponent<Props> = ({ locale, marketCode, children }) => {
  const { features, verticalName } = useVerticalConfig();

  if (features?.configurePillowTalk) {
    return <PillowTalkWrapper>{children}</PillowTalkWrapper>;
  }

  return (
    <LivePersonMessagingProvider locale={locale} marketCode={marketCode} vertical={verticalName}>
      {children}
    </LivePersonMessagingProvider>
  );
};

export default MessagingProviderWrapper;
